/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSnowmobileIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-snowmobile"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.38 17.68L8.07 17.68Q8.72 17.68 9.18 17.26Q9.63 16.85 9.63 16.23L7.35 15.53L3.38 17.68Q3.38 17.68 3.38 17.68Q3.38 17.68 3.38 17.68Q3.38 17.68 3.38 17.68Q3.38 17.68 3.38 17.68ZM24.07 18Q24.07 18.15 24.05 18.3Q24.02 18.45 23.95 18.57Q23.52 19.38 22.75 19.85Q21.98 20.32 21.07 20.32L16.07 20.32Q15.53 20.32 15.14 19.94Q14.75 19.55 14.75 19Q14.75 18.45 15.14 18.06Q15.53 17.68 16.07 17.68L17.23 17.68L15.88 16.32L12.38 16.32Q12.38 18.02 11.09 19.18Q9.8 20.32 8.07 20.32L2.08 20.32Q0.97 20.32 0.36 19.6Q-0.25 18.88 -0.25 18Q-0.25 17.43 0.04 16.88Q0.33 16.32 0.97 15.97L3.77 14.45L1.88 13.88Q1 13.6 0.61 12.75Q0.23 11.9 0.65 11.07L1.25 9.9Q1.52 9.32 2.08 9.03Q2.63 8.72 3.25 8.8L10.97 9.68L13.63 7.7L13.2 7.33Q13.2 7.33 13.2 7.33Q13.2 7.33 13.2 7.33L12.07 7.33Q11.53 7.33 11.14 6.94Q10.75 6.55 10.75 6Q10.75 5.45 11.14 5.06Q11.53 4.67 12.07 4.67L13.2 4.67Q13.7 4.67 14.16 4.85Q14.63 5.03 15 5.38L21.82 11.7Q22.1 11.95 22.25 12.39Q22.4 12.82 22.4 13.25Q22.4 14.45 21.77 15.32Q21.15 16.2 19.57 16.32L19.57 16.32L21.02 17.68L21.07 17.68Q21.23 17.68 21.35 17.6Q21.48 17.52 21.57 17.38Q21.77 17.05 22.09 16.86Q22.4 16.68 22.75 16.68Q23.3 16.68 23.69 17.06Q24.07 17.45 24.07 18Z" fill={color} />
    </svg>
  );
}
